import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import styles from './SearchBar.module.scss';
import { Input } from 'components/UI/V3/Forms/Input/Input';

interface SearchBarProps {
    id?: string;
    searchText: string;
    placeholder: string;
    className?: string;
    rightActions?: React.ReactNode;
    onChangeSearchText: (text: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ ...props }) => {
    const searchIcon = (
        <FontAwesomeIcon
            icon={faSearch}
            className={styles.searchIcon}
        />
    );

    return (
        <div className={clsx(styles.searchContainer, props.className)}>
            <div className={styles.inputContainerSearch}>
                <div className={clsx(styles.inputBox, props.rightActions && styles.inputBoxWithRightActions)}>
                    <Input
                        id={props.id}
                        placeholder={props.placeholder}
                        className={styles.searchInput}
                        value={props.searchText}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => props.onChangeSearchText(e.target.value)}
                        startIcon={searchIcon}
                        autoFocus={false}
                    />
                    {props.rightActions && <div className={styles.rightActions}>{props.rightActions}</div>}
                </div>
            </div>
        </div>
    );
};

export default SearchBar;
